import { jsx as t } from "react/jsx-runtime";
import { IconContainer as a, Svg as c } from "./styles.js";
function p({ icon: o, ...n }) {
  const [r, e, d, h, i] = o.icon;
  return /* @__PURE__ */ t(
    a,
    {
      "data-name": o.iconName,
      "data-testid": "icon",
      role: "presentation",
      ...n,
      children: /* @__PURE__ */ t(c, { viewBox: `0 0 ${r} ${e}`, children: /* @__PURE__ */ t("path", { fill: "currentColor", d: i }) })
    }
  );
}
export {
  p as Icon
};
